import * as React from "react";
import "./styles.css";

// could be much stricter, enumarate all the media features and their values
// https://developer.mozilla.org/en-US/docs/Web/CSS/@media#media_features
type MediaQuery = `(${string}:${string})`;

type FormatDebugValue = {
  query: MediaQuery;
  matches: boolean;
}

const formatDebugValue = ({
  query,
  matches,
}: FormatDebugValue) => `\`${query}\` => ${matches}`;

function getSnapshot(query: MediaQuery) {
  return window.matchMedia(query).matches;
}

function subscribe(onChange: any, query: MediaQuery) {
  const mql = window.matchMedia(query);
  mql.addEventListener("change", onChange);

  return () => {
    mql.removeEventListener("change", onChange);
  };
}

export function useMedia(query: MediaQuery, initialState = false) {  
  
  /* If a different subscribe function is passed during
  a re-render, React will re-subscribe to the store using
  the newly passed subscribe function. You can prevent this
  by declaring subscribe outside the component. */
  const subscribeMediaQuery = React.useCallback((onChange: () => void) => {
    subscribe(onChange, query)
  }, [query])

  const matches = React.useSyncExternalStore(
    subscribeMediaQuery, 
    () => getSnapshot(query),
    () => initialState,
  );

  React.useDebugValue({ query, matches }, formatDebugValue);

  return matches;
}

